module.exports = __webpack_public_path__ + "46bf394bf74cfed4ecea5571d7202358.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-winter-pink-s.png
// module id = 2298
// module chunks = 0